import { useEffect, useState } from 'react';
import type { RecruitmentImage } from '../types/recruitments';
import { MAX_RECRUITMENT_IMAGES } from '../types/recruitmentForm';

const getDisplayImages = (
  images: RecruitmentImage[] | undefined,
  noimage: string
): RecruitmentImage[] => {
  if (images && images.length > 0) {
    return images.slice(0, MAX_RECRUITMENT_IMAGES);
  }

  return [{ id: -1, url: noimage }];
};

export const useSwapCoverThumbsSlider = (
  images: RecruitmentImage[] | undefined,
  noimage: string
) => {
  const [displayImages, setDisplayImages] = useState<RecruitmentImage[]>(
    () => getDisplayImages(images, noimage)
  );
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setDisplayImages(getDisplayImages(images, noimage));
    setCurrentIndex(0);
  }, [images, noimage]);

  const handleSubImageClick = (index: number) => {
    setCurrentIndex(index);
  };

  return {
    displayImages,
    currentIndex,
    handleSubImageClick,
    setCurrentIndex,
  };
};
